import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { firebaseInitError } from '../lib/firebase';

export default function LoginPage() {
  const { login, authError, clearAuthError, authLoading, isAuthenticated, theme, businessType } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const primary = theme?.colors?.primary || '#7B1FA2';
  const primaryDark = theme?.colors?.primaryDark || '#6A1B9A';

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    clearAuthError();
    const ok = await login(email.trim(), password);
    if (ok) {
      const dest = location.state?.from || '/admin/dashboard';
      navigate(dest, { replace: true });
    }
  };

  return (
    <div
      className="login-page"
      style={{ '--primary': primary, '--primary-dark': primaryDark }}
    >
      <div className="login-card">
        <div className="login-brand">
          <span className="brand-mark large">MF</span>
          <h1>MI FACTURADOR</h1>
          <p className="muted">{theme?.tagline || 'Panel administrativo de empresa'}</p>
        </div>

        {firebaseInitError ? (
          <div className="alert error" role="alert">{firebaseInitError}</div>
        ) : null}

        <form onSubmit={onSubmit} className="login-form">
          <label>
            Correo
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Contraseña
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {authError?.message ? (
            <div className="alert error" role="alert">{authError.message}</div>
          ) : null}
          <button type="submit" className="btn btn-primary btn-block" disabled={authLoading}>
            {authLoading ? 'Ingresando…' : 'Iniciar sesión'}
          </button>
        </form>
        <p className="login-foot muted">
          Usa la misma cuenta de la app móvil. Vertical detectada al cargar la empresa.
        </p>
        {businessType ? <p className="login-vertical">{businessType}</p> : null}
      </div>
    </div>
  );
}
